import type {
  EmailLoginRequest,
  EmailLoginResponse,
  LoginSuccessResponse,
  MessageResponse,
  MfaVerifyRequest,
  PasskeyBeginResponse,
  PasskeyFinishRequest,
  PasswordResetConfirmRequest,
  PasswordResetRequest,
  RegisterRequest,
  VerifyRequest,
} from '@/types';
import { httpClient } from './httpClient';

const BASE = '/api/auth';

export async function register(data: RegisterRequest): Promise<MessageResponse> {
  const response = await httpClient.post<MessageResponse>(`${BASE}/register`, data);

  return response.data;
}

export async function verify(data: VerifyRequest): Promise<MessageResponse> {
  const response = await httpClient.post<MessageResponse>(`${BASE}/verify`, data);

  return response.data;
}

export async function emailLogin(data: EmailLoginRequest): Promise<EmailLoginResponse> {
  const response = await httpClient.post<EmailLoginResponse>(`${BASE}/email-login`, data);

  return response.data;
}

export async function loginMFAVerify(data: MfaVerifyRequest): Promise<LoginSuccessResponse> {
  const response = await httpClient.post<LoginSuccessResponse>(`${BASE}/login/mfa/verify`, data);

  return response.data;
}

export async function passkeyLoginBegin(): Promise<PasskeyBeginResponse> {
  const response = await httpClient.post<PasskeyBeginResponse>(`${BASE}/passkeys/login/begin`, {});

  return response.data;
}

export async function passkeyLoginFinish(
  data: PasskeyFinishRequest,
): Promise<LoginSuccessResponse> {
  const response = await httpClient.post<LoginSuccessResponse>(
    `${BASE}/passkeys/login/finish`,
    data,
  );

  return response.data;
}

export async function passwordReset(data: PasswordResetRequest): Promise<MessageResponse> {
  const response = await httpClient.post<MessageResponse>(`${BASE}/password-reset`, data);

  return response.data;
}

export async function passwordResetConfirm(
  data: PasswordResetConfirmRequest,
): Promise<MessageResponse> {
  const response = await httpClient.post<MessageResponse>(`${BASE}/password-reset/confirm`, data);

  return response.data;
}
